
<div class="stage-view-wrapper">
	<div class="stage-view-header">
		<!-- @slot Used to display stage view header  -->
		<slot name="header" />
	</div>
	<div class="stage-view-body">
		<!-- @slot Used to display stage view content -->
		<slot />
	</div>
</div>
